import React from "react";
import { ElementComponentProps } from "elements/types";
import { useSelector } from "react-redux";
import { getBinding } from "data/form/elementSelectors";
import { State } from "data";
import Element from "components/Forms/Element";
import { MultiRefViewElement } from "records/Element";
import { getRowCount } from "data/form/formSelectors";
import _ from "lodash";

function MultiRefView({
	traversal,
	uuid,
	fid,
	label,
	hint,
	id,
	vid,
	disabled,
}: ElementComponentProps<MultiRefViewElement>) {
	const binding = useSelector((state: State) =>
		getBinding(state, { fid, vid })
	);

	const rowCount = useSelector((state: State) => {
		if (!binding) return 0;
		return getRowCount(state, fid, binding);
	});

	return (
		<fieldset className="elem elem-multiRefView card">
			<div className="card-header">
				<legend className="elem__label mb-0">{label}</legend>
			</div>

			<div className="card-body">
				{hint && <p className="elem__hint">{hint}</p>}
				{/* {feedback && (
					<div className={`elem--${status}`}>
						<div className="elem__feedback">{feedback}</div>
					</div>
				)} */}
			</div>

			<ul className="list-group list-group-flush">
				{_.times(rowCount, index => (
					<li
						key={`${uuid}/${index}`}
						className="elem-multiRefView__row list-group-item">
						{traversal.map(uuid => {
							return (
								<Element
									rowIndex={index}
									key={uuid}
									fid={fid}
									uuid={uuid}
									disabled={disabled}
								/>
							);
						})}
					</li>
				))}
			</ul>
		</fieldset>
	);
}

export default React.memo(MultiRefView);
